import axios from "axios";
import { trackPromise } from "react-promise-tracker";
import * as CommonVariables from '../../Common/CommonVariables';

export const SalesAdminLoginTrackingReport = async () => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `MHL_Reports/SalesAdminLoginTrackingReport`, {}, CommonVariables.API_HEADER)).then(response => response);
    return result;
}